import API from '@ogsnetwork/opp-api-lib';
export const api = {
    instance: Promise.reject({ type: 'API_NOT_INITIATED' })
};
export function initAPI(configuration) {
    var _a, _b;
    const API_BASE_URL = [configuration.api.host, configuration.api.path].join('/');
    const instance = new API({
        authenticationMethod: configuration.authenticationMethod,
        autoAuth: false,
        baseUrl: API_BASE_URL,
        clientRequestGeolocationData: configuration.locationServices.getGeolocation,
        geolocationRequired: configuration.locationServices.enabled,
        platform: configuration.platform
    });
    const watchPositionWhenRequireLocationServices = ['always', 'ask'];
    if (configuration.locationServices.watchPositionChange &&
        watchPositionWhenRequireLocationServices.includes(configuration.locationServices.enabled)) {
        (_b = (_a = configuration.locationServices).watchPosition) === null || _b === void 0 ? void 0 : _b.call(_a, instance.updateGeolocationData);
    }
    api.configuration = configuration;
    api.instance = Promise.resolve(instance);
}
